<template>
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.25 18.7372L7.87501 14.3614L9.11138 13.125L12.25 16.2628L18.8869 9.625L20.125 10.8631L12.25 18.7372Z"
      fill="var(--color, #04785E)"
    />
    <path
      d="M14 1.75C11.5772 1.75 9.20877 2.46845 7.19427 3.8145C5.17977 5.16054 3.60965 7.07373 2.68248 9.31213C1.75531 11.5505 1.51272 14.0136 1.98539 16.3899C2.45805 18.7661 3.62475 20.9489 5.33795 22.6621C7.05114 24.3753 9.23388 25.542 11.6101 26.0146C13.9864 26.4873 16.4495 26.2447 18.6879 25.3175C20.9263 24.3904 22.8395 22.8202 24.1855 20.8057C25.5316 18.7912 26.25 16.4228 26.25 14C26.25 10.7511 24.9594 7.63526 22.6621 5.33794C20.3647 3.04062 17.2489 1.75 14 1.75ZM14 24.5C11.9233 24.5 9.89323 23.8842 8.16652 22.7304C6.4398 21.5767 5.09399 19.9368 4.29927 18.0182C3.50455 16.0996 3.29662 13.9884 3.70176 11.9516C4.1069 9.91475 5.10693 8.04383 6.57538 6.57538C8.04384 5.10693 9.91476 4.1069 11.9516 3.70175C13.9884 3.29661 16.0996 3.50454 18.0182 4.29926C19.9368 5.09398 21.5767 6.4398 22.7304 8.16651C23.8842 9.89323 24.5 11.9233 24.5 14C24.5 16.7848 23.3938 19.4555 21.4246 21.4246C19.4555 23.3938 16.7848 24.5 14 24.5Z"
      fill="var(--color, #04785E)"
    />
  </svg>
</template>
